import { Bot } from "lucide-react";

/**
 * The agent's in-progress reply, shown as a live chat bubble while its text
 * streams in (ENG-389). Callers render it only while the agent still owes the
 * turn, so it disappears once the stored turn replaces it.
 */
export function DraftReplyBubble({ text }: { text: string }) {
  return (
    <div className="flex gap-3" data-testid="agent-draft">
      <div className="h-8 w-8 shrink-0 rounded-full flex items-center justify-center bg-purple-900/30 text-purple-300">
        <Bot className="h-4 w-4" />
      </div>
      <div
        className="rounded-lg px-4 py-2.5 text-sm max-w-[75%] whitespace-pre-wrap bg-white/[0.04] border border-white/[0.06]"
        aria-live="polite"
        aria-busy="true"
      >
        {text}
        <span className="ml-0.5 inline-block h-3.5 w-1.5 animate-pulse bg-current align-middle opacity-60" aria-hidden="true" />
      </div>
    </div>
  );
}
